/* <faq-filters>: category filtering for the FAQ page.
   The Q&A accordions are native <details>, so answers stay reachable with JS
   off. The tab row ships `hidden` and is only revealed here — no dead controls
   for no-JS visitors, who simply get the full list. */
(() => {
  class FaqFilters extends HTMLElement {
    connectedCallback() {
      this.tabs = this.querySelector('[data-faq-tabs]');
      this.list = this.querySelector('[data-faq-list]');
      this.status = this.querySelector('[data-faq-status]');
      if (!this.tabs || !this.list) return;

      this.items = Array.from(this.list.querySelectorAll('.faq-item'));
      if (!this.items.length) return;

      this.tabs.hidden = false;

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-faq-filter]');
        if (button && this.tabs.contains(button)) this.apply(button);
      });
    }

    apply(button) {
      const filter = button.getAttribute('data-faq-filter');

      this.tabs.querySelectorAll('[data-faq-filter]').forEach((tab) => {
        tab.setAttribute('aria-pressed', tab === button ? 'true' : 'false');
      });

      let shown = 0;
      this.items.forEach((item) => {
        const match = filter === 'all' || item.getAttribute('data-faq-cat') === filter;
        item.hidden = !match;
        if (match) shown += 1;
        else item.open = false;
      });

      if (this.status) {
        this.status.textContent = shown + (shown === 1 ? ' question' : ' questions') + ' shown';
      }
    }
  }

  if (!window.customElements.get('faq-filters')) {
    window.customElements.define('faq-filters', FaqFilters);
  }
})();
